import { Component, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { AppConfigService } from '../../services/config/app-config.service';
import { CommonUtilService } from '../../services/common-util/common-util.service';
import { WishlistDialogComponent } from '../../views/common/wishlist-dialog/wishlist-dialog.component';
import { RouterModule } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MasterSearchTransmissionService } from '../../services/raintree/Transmission/master-search.service';
import { RefreshedDateKey } from '../../enum/refresh-date';
import { DpTabMenuV3Component } from '../../common-component/dp-tab-menu-v3/dp-tab-menu-v3.component';
@Component({
  selector: 'app-reach-defaulter-main',
  standalone: true,
  templateUrl: './reach-defaulter-main.component.html',
  styleUrl: '../reach-defaulter.component.scss',
  imports: [
    DpTabMenuV3Component,
    RouterModule,
  ],
  providers: [DatePipe]
})
export class ReachDefaulterMainComponent implements OnInit {
  isMobileDevice: boolean = false;
  reachAccess: boolean = false;
  permission: any;
  lastRefreshedDate: any
  constructor(
    private isMobile: CommonUtilService,
    private appConfigService: AppConfigService,
    private dialog: MatDialog,
    private masterSearchService: MasterSearchTransmissionService,
    public datePipe: DatePipe
  ) { }
  ngOnInit(): void {
    this.isMobileDevice = this.isMobile.isMobileDevice();
    this.permission = this.appConfigService.getAllPermissionsV3();
    const permList = this.fetchPermName(this.permission)
    this.fetchLastRefreshedDate()
  }
  fetchPermName(perm: any, finalPermList: any = []) {
    Object.values(perm).forEach((item: any) => {
      if (typeof (item) === 'object' && item['Defaulter List']) {
        this.reachAccess = item['Defaulter List']['Reached'] ? true : false
      }
      else if (typeof (item) === 'object' && item['Defaulter List'])
        this.fetchPermName(item)
    })
    return
  }
  fetchLastRefreshedDate() {
    let refreshDate: any = JSON.parse(decodeURIComponent(atob(localStorage.getItem('refresh-date')!)))
    if (refreshDate) {
      this.lastRefreshedDate = refreshDate.filter((item: any) => item.configName.includes(RefreshedDateKey.Defaulter))
      this.lastRefreshedDate = this.datePipe.transform(this.lastRefreshedDate[0].date, 'MMM d, y')
    }
  }
  onWishlistClick(data: string, row: any) {
    if (data === 'Reach')
      this.dialog.open(WishlistDialogComponent, {
        data: { type: data, row: row },
      });
    else
      this.dialog.open(WishlistDialogComponent, {
        data: { type: data },
      });
  }
}
